import { Outlet } from 'react-router-dom'
import { Header } from '@/app/components/Header'
import { Footer } from '@/app/components/Footer'

/**
 * AppLayout.tsx
 * Authenticated app shell.
 * Rendered by ProtectedRoute; child routes appear in <Outlet />.
 *
 * Structure:
 *   ┌─────────────────────────────┐
 *   │  Header (top bar)           │
 *   ├─────────────────────────────┤
 *   │  <Outlet /> (route content) │
 *   ├─────────────────────────────┤
 *   │  Footer                     │
 *   └─────────────────────────────┘
 */
export function AppLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-gray-50">
      {/* Header is position:fixed (56px) — pt-14 below compensates for overlap */}
      <Header />
      <main className="flex-1 pt-14">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
